/**
 * @deprecated
 */
export enum SubscriptionStatus {
  /**
   * создана новая чистая подписка (чистая означает, что она не создана из уже существующей путем смены тарифа)
   */
  Created = 1,
  /**
   * Создан платеж для подписки, но еще не оплачен.
   * Пока подписка в этом статусе, совершаются попытки оплатить.
   */
  Pending = 2,
  /**
   * Подписка успешно оплачена и действует
   */
  Active = 3,
  /**
   * Подписка отменена.
   * Переходит в этот статус если не удалось оплатить
   */
  Cancelled = 4,
  Expired = 5,
}

export const INACTIVE_SUBSCRIPTION_STATUSES: SubscriptionStatus[] = [SubscriptionStatus.Cancelled, SubscriptionStatus.Expired];
